const masterDetailActionsPrefix = "master-detail";

export const masterDetailActions = {
  OPEN_ROW: `${masterDetailActionsPrefix}/open-row`,
  CLOSE_ROW: `${masterDetailActionsPrefix}/close-row`,
};
